var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16772,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6677 16H16.6677V21C16.6677 21.2652 16.5624 21.5196 16.3748 21.7071C16.1873 21.8946 15.9329 22 15.6677 22C15.4025 22 15.1482 21.8946 14.9606 21.7071C14.7731 21.5196 14.6677 21.2652 14.6677 21V16H9.66772C9.40251 16 9.14815 15.8946 8.96062 15.7071C8.77308 15.5196 8.66772 15.2652 8.66772 15C8.66772 14.7348 8.77308 14.4804 8.96062 14.2929C9.14815 14.1054 9.40251 14 9.66772 14H14.6677V9C14.6677 8.73478 14.7731 8.48043 14.9606 8.29289C15.1482 8.10536 15.4025 8 15.6677 8C15.9329 8 16.1873 8.10536 16.3748 8.29289C16.5624 8.48043 16.6677 8.73478 16.6677 9V14H21.6677C21.9329 14 22.1873 14.1054 22.3748 14.2929C22.5624 14.4804 22.6677 14.7348 22.6677 15C22.6677 15.2652 22.5624 15.5196 22.3748 15.7071C22.1873 15.8946 21.9329 16 21.6677 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.6547d6e4e8d143c924abbaaeba80ec76.svg";
export { ForwardRef as ReactComponent };